export const environment = {
  production: false,
  googleMapKey: 'AIzaSyDwCR_nyH6h2U7ladZSon4DaSj4DKa9YgQ',
  stripeKey:
    'pk_test_51Tt5L6CARRuO811EvHDyGrl1Jytihid7VkONltB3gTr9h7E82GM7rdBS6zpCeT0iHNdk1QHdzpl3WXXzjy1j0RTJ00Z4jyLx21',
  urlSsoSso: 'https://idam.dev.mobilitycompany.it/auth/welcome',
  urlSsoLogout: 'https://idam.dev.mobilitycompany.it/auth/logout',
  urlSsoRegister: 'https://idam.dev.mobilitycompany.it/auth/register',
  urlSsoRecovery: 'https://idam.dev.mobilitycompany.it/auth/password-recovery',
  apiUrl: 'https://api.dev.mobilitycompany.it',
  ambient: 'dev'
};
